import { physicalInfrastructureEnumsAffectedRedundancyLevelOptionEnum } from '@/gen/types/PhysicalInfrastructureEnumsAffectedRedundancyLevelOption';
import { physicalInfrastructureEnumsCurrentStatusOptionEnum } from '@/gen/types/PhysicalInfrastructureEnumsCurrentStatusOption';
import { physicalInfrastructureEnumsFaultTypeOptionEnum } from '@/gen/types/PhysicalInfrastructureEnumsFaultTypeOption';
import { physicalInfrastructureEnumsPotentialConsequenceOptionEnum } from '@/gen/types/PhysicalInfrastructureEnumsPotentialConsequenceOption';

import { whenPathIncludes } from './conditions';
import type { IncidentFieldRule } from './types';

export const physicalInfrastructureFieldRules: IncidentFieldRule[] = [
    {
        key: 'subCategory',
        label: 'Type of physical infrastructure issue',
        description: 'Select the type of physical infrastructure issue observed.',
        order: 90,
    },
    {
        key: 'powerAssetID',
        label: 'Asset ID',
        description: 'Enter the asset ID (e.g., UPS-02, GEN-01).',
        order: 100,
    },
    {
        key: 'powerLocation',
        label: 'Where is the affected asset located?',
        description: 'Enter the data hall number, rack, or zone. Be as specific as possible.',
        order: 110,
    },
    {
        key: 'potentialConsequence',
        label: 'Potential operational consequences',
        description: 'Select all potential consequences, e.g. downtime, capacity loss.',
        order: 120,
    },
    {
        key: 'potentialConsequenceExplanation',
        label: 'Potential consequence explanation',
        kind: 'textarea',
        order: 130,
        visibleWhen: whenPathIncludes('potentialConsequence', physicalInfrastructureEnumsPotentialConsequenceOptionEnum.Other),
        requiredWhen: whenPathIncludes(
            'potentialConsequence',
            physicalInfrastructureEnumsPotentialConsequenceOptionEnum.Other,
        ),
    },
    {
        key: 'currentStatus',
        label: 'Current status of the asset',
        description: 'Select the current operational state of the affected asset.',
        order: 140,
    },
    {
        key: 'currentStatusExplanation',
        label: 'Current status explanation',
        kind: 'textarea',
        order: 150,
        visibleWhen: whenPathIncludes('currentStatus', physicalInfrastructureEnumsCurrentStatusOptionEnum.Other),
        requiredWhen: whenPathIncludes('currentStatus', physicalInfrastructureEnumsCurrentStatusOptionEnum.Other),
    },
    {
        key: 'affectedRedundancyLevel',
        label: 'Affected redundancy level',
        description: 'Select the redundancy level impacted, e.g. N, N+1, 2N.',
        order: 160,
    },
    {
        key: 'affectedRedundancyLevelExplanation',
        label: 'Affected redundancy level explanation',
        kind: 'textarea',
        order: 170,
        visibleWhen: whenPathIncludes(
            'affectedRedundancyLevel',
            physicalInfrastructureEnumsAffectedRedundancyLevelOptionEnum.Other,
        ),
        requiredWhen: whenPathIncludes(
            'affectedRedundancyLevel',
            physicalInfrastructureEnumsAffectedRedundancyLevelOptionEnum.Other,
        ),
    },
    {
        key: 'faultType',
        label: 'What type of fault occurred?',
        description: 'Select the type of fault, e.g. mechanical, electrical, software.',
        order: 180,
    },
    {
        key: 'faultTypeExplanation',
        label: 'Fault type explanation',
        kind: 'textarea',
        order: 190,
        visibleWhen: whenPathIncludes('faultType', physicalInfrastructureEnumsFaultTypeOptionEnum.Other),
        requiredWhen: whenPathIncludes('faultType', physicalInfrastructureEnumsFaultTypeOptionEnum.Other),
    },
    {
        key: 'alarmCodeSource',
        label: 'Source of the alarm or alert',
        description: 'Enter the system or tool that generated the alarm, e.g. BMS, DCIM.',
        order: 200,
    },
    {
        key: 'unplannedEmission',
        label: 'Did this cause unplanned CO2 emissions?',
        description: 'Select Yes if the incident caused unexpected CO2 emissions.',
        order: 210,
    },
];
